export const tests ={
  CAREGIVER_PAYWALL_STRIPE_PAYMENT: 'disabled', // WEB-12681: Temporarily disable 'cz' test group
};
